import { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import RandomQuote from "../../components/RandomQuote/RandomQuote";
import BrandTitle from "../../components/BrandTitle/BrandTitle";

export default function ResetPasswordPage() {
  const { token } = useParams();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [status, setStatus] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirm) {
      setStatus("Passwords do not match");
      return;
    }

    const res = await fetch(
      `${import.meta.env.VITE_API_URL}/api/auth/reset-password/${token}`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ password }),
      }
    );

    const data = await res.json();
    if (!res.ok) return setStatus(data.error || "Reset failed");

    setStatus("Password reset. Redirecting...");
    setTimeout(() => navigate("/login"), 3000);
  };

  return (
    <div className="authentication-view">
      <div className="left-wrapper">
        <div className="title">
          <BrandTitle fontSize={40} className="brand-title-login" />
        </div>
        <div className="quote">
          <RandomQuote />
        </div>
      </div>
      <div className="right-wrapper">
        <div className="title">Reset Password</div>
        <form onSubmit={handleSubmit} autoComplete="off">
          <input
            name="flow-password"
            className="flow-form"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="New Password"
            autoComplete="new-password"
            required
          />
          <br />
          <input
            name="flow-confirmPassword"
            className="flow-form"
            type="password"
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
            placeholder="Confirm Password"
            autoComplete="new-confirm-password"
            required
          />
          <br />
          <button type="submit" className="flow-button">
            Reset Password
          </button>
        </form>
        {status && (
          <span
            style={{
              color: "var(--success-color)",
              marginTop: "10px",
              marginBottom: "-10px",
            }}
          >
            {status}
          </span>
        )}
        <p>
          <a className="link" href="/login">
            &larr; Back to login
          </a>
        </p>
      </div>
    </div>
  );
}
